import type { Client, DirectStore } from '@/modules/shared/types'

/** A direct store rendered through the client route tree, as a Client shape. */
export function directStoreToClient(s: DirectStore): Client {
  return {
    id: s.id,
    organizationId: s.orgId,
    name: s.name,
    slug: s.slug,
    platform: 'tiktok',
    onboardingStatus: s.onboardingStatus,
    // Direct stores are live engagements; 'active' keeps every store page reachable.
    phase: 'active',
    role: s.role,
    isFavorite: false,
  }
}
